'use strict';

var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var r = require('clsx');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var r__default = /*#__PURE__*/_interopDefault(r);

var N=({nextImage:e,imageUrl:o,imageAltTag:m,quoteText:n,quoteSource:t,color:d,linkType:s,className:g})=>{let u=`${chunk32OAM7MJ_js.a}-quote-card`,p=r__default.default(u,g),i=!!e;return jsxRuntime.jsx("div",{className:p,style:{backgroundColor:d},children:jsxRuntime.jsx("figure",{children:jsxRuntime.jsxs("div",{className:"content",children:[i&&e,!i&&!!o&&jsxRuntime.jsx("img",{src:o,alt:m,loading:"lazy"}),jsxRuntime.jsxs("div",{className:r__default.default("quote-wrapper",{"has-image":e||o}),children:[jsxRuntime.jsx("blockquote",{className:"quote-text",children:n}),t&&jsxRuntime.jsx("figcaption",{className:"quote-source",children:t}),s&&jsxRuntime.jsx("div",{className:"link-wrapper",children:s})]})]})})})},f=N;

exports.a = f;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-CK2JYCNS.js.map